module.exports = __webpack_public_path__ + "static/media/Background@3x.5b8e011a.png";